<section class="dash-page">
  <div class="dash-content">
    <div class="grid">

      <div class="col-12">
        <div class="dash-card h-full">
          <div class="dash-header">
            <div class="inline-flex align-items-center gap-2">
              <h2
                class="dash-title mb-0">{{ 'components.dashboard-general-sisben.historico-tramites-by-mes' | translate }}</h2>
            </div>
          </div>
          <div class="dash-body">
            <app-chart-line #chartLineHistorico [config]="lineHistoricoConfig"/>
          </div>
        </div>
      </div>


      <div class="col-12 lg:col-6">
        <div class="dash-card h-full">
          <div class="dash-header">
            <div class="inline-flex align-items-center gap-2">
              <h2 class="dash-title mb-0">{{ 'components.dashboard-general-sisben.global-tramites' | translate }}</h2>
            </div>
          </div>
          <div class="dash-body">
            <app-chart-donut #chartDonutGlobal [config]="chartDonutConfig"/>
          </div>
        </div>
      </div>

      <div class="col-12 lg:col-6">
        <div class="dash-card h-full">
          <div class="dash-header">
            <div class="inline-flex align-items-center gap-2">
              <h2
                class="dash-title mb-0">{{ 'components.dashboard-general-sisben.efectividad-global' | translate }}</h2>
            </div>
          </div>
          <div class="dash-body">
            <app-chart-radial-gauge #chartRadialGaugeEfectividad [config]="radialGaugeEfectividadConfig"/>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="dash-card h-full">
          <div class="dash-header">
            <div class="inline-flex align-items-center gap-2">
              <h2 class="dash-title mb-0">{{ 'components.dashboard-general-sisben.tramites' | translate }}</h2>
            </div>
          </div>
          <div class="dash-body">
            <app-chart-bar #chartBarTramites [config]="barTramitesConfig" style="min-height:180px"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
